exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dtlp-load-more-button {\n  padding: 8px 8px 4px;\n  -webkit-transition: padding 200ms ease-in-out;\n  transition: padding 200ms ease-in-out;\n}\n.dtlp-load-more-button button {\n  font-size: 18px !important;\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.dtlp-load-more-button--hide {\n  padding: 0;\n}\n.dtlp-load-more-button__stats {\n  position: relative;\n  top: -1px;\n  margin-left: 10px;\n  font-size: 14px;\n}\n.dtlp-load-more-button__button {\n  width: 100%;\n}\n", ""]);

// exports
